export const GET_CONTRACT = 'GET_CONTRACT_IN_TOURPLAN_INTEGRATION';
export const GET_CONTRACT_STARTING = 'GET_CONTRACT_STARTING_IN_TOURPLAN_INTEGRATION';
export const GET_CONTRACT_FAILED = 'GET_CONTRACT_FAILED_IN_TOURPLAN_INTEGRATION';

export const CLEAR_STORES = 'CLEAR_STORES_IN_TOURPLAN_INTEGRATION';
export const CLEAR_EXPORT_STATE = 'CLEAR_EXPORT_STATE_IN_TOURPLAN_INTEGRATION';
export const LOGIN = 'LOGIN_IN_TOURPLAN_INTEGRATION';

export const GET_CONTRACTS = 'GET_CONTRACTS_IN_TOURPLAN_INTEGRATION';
export const GET_CONTRACTS_STARTING = 'GET_CONTRACTS_STARTING_IN_TOURPLAN_INTEGRATION';
export const GET_CONTRACTS_FAILED = 'GET_CONTRACTS_FAILED_IN_TOURPLAN_INTEGRATION';

export const ADD_MAPPING = 'ADD_MAPPING_IN_TOURPLAN_INTEGRATION';
export const ADD_MAPPING_STARTING = 'ADD_MAPPING_STARTING_IN_TOURPLAN_INTEGRATION';
export const ADD_MAPPING_FAILED = 'ADD_MAPPING_FAILED_IN_TOURPLAN_INTEGRATION';

export const VALIDATE_MAPPING = 'VALIDATE_MAPPING_IN_TOURPLAN_INTEGRATION';
export const VALIDATE_MAPPING_STATUS = 'VALIDATE_MAPPING_STATUS_IN_TOURPLAN_INTEGRATION';
export const CHECK_RATES_STARTING = 'CHECK_RATES_STARTING_IN_TOURPLAN_INTEGRATION';
export const CHECK_IF_HAS_RATES = 'CHECK_IF_HAS_RATES_IN_TOURPLAN_INTEGRATION';
export const CHECK_IF_HAS_RATES_FAILED = 'CHECK_IF_HAS_RATES_FAILED_IN_TOURPLAN_INTEGRATION';

export const GET_AUTH = 'GET_AUTH_IN_TOURPLAN_INTEGRATION';
export const GET_AUTH_FAILED = 'GET_AUTH_FAILED_IN_TOURPLAN_INTEGRATION';
export const CLEAR_INTEGRATION_STORE = 'CLEAR_INTEGRATION_STORE_IN_TOURPLAN_INTEGRATION';

export const CHANGE_INTEGRATION_EXPORT_TYPE = 'CHANGE_INTEGRATION_EXPORT_TYPE_IN_TOURPLAN_INTEGRATION';
export const LOG_OUT = 'LOG_OUT_IN_TOURPLAN_INTEGRATION';

export const UPDATE_SETTINS = 'UPDATE_EXPORT_SETTINGS_IN_INTEGRATION';

export const GETTING_CONVERTED_CONTRACT = 'GETTING_CONVERTED_CONTRACT_IN_INTEGRATION';
export const GET_CONVERTED_CONTRACT = 'GET_CONVERTED_CONTRACT_IN_INTEGRATION';
export const GETTING_CONVERTED_CONTRACT_FAILED = 'GETTING_CONVERTED_CONTRACT_FAILED_IN_INTEGRATION';

export const UPDATE_WITH_KEYPATH = 'UPDATE_WITH_KEYPATH_IN_INTEGRATION';

export const UPDATE_PRODUCT = 'UPDATE_PRODUCT_IN_INTEGRATION';




// WEBPACK FOOTER //
// ./src/app/stores/integration/integration-constants.js